import React, { useState } from 'react'
import getVectorImage from '../../utils/getVectorImage'
import styles from './SideTable.module.scss'
import toTitleCase from '../../utils/toTitleCase'
import { useGeoState } from '../../components/GeoProvider'
import { useHistory } from 'react-router-dom'
const Databind = ({ state, chartRef }) => {
  const { regionSelected } = useGeoState()
  const history = useHistory()

  const handleMouseOver = (element) => {
       if (chartRef.current != null) {
      const chart = chartRef.current.chart
      var indexSeries =
        regionSelected === 'metro' ? 1 : regionSelected === 'zip3' ? 2 : 0
      if (chart !== undefined && chart !== null) {
        
        if(indexSeries == 1){
            const geoParentValue = element.attributes['geo_parent'].textContent;
            const geoIdValue = element.attributes['geo_id'].textContent;
  
            const point = chart.series[indexSeries].points.find(function(point) {
            const geoIdMatch = point.geo_id === geoIdValue;
  
            if (!geoIdMatch) return false;
  
            if (point.geo_parent.includes(',')) {
                const geoArray = point.geo_parent.split(',');
                if (geoArray.includes(geoParentValue)) {
                  return true;
               }
            } else {
                if (point.geo_parent === geoParentValue) {
                  return true;
            }
        }
          return false;
      });
      
      if (point) {
      const originalGeoParent = point.geo_parent; 
      point.update({ geo_parent: geoParentValue }, false); // update without redraw
      chart.tooltip.refresh(point);
      point.update({ geo_parent: originalGeoParent }, false); // restore original

        // const pointAfterUpdate = Object.assign({}, point);
        // pointAfterUpdate.geo_parent = geoParentValue;
        // pointAfterUpdate && chart.tooltip.refresh(pointAfterUpdate); 
      }
        }
        else{
          const point = chart.series[indexSeries].points.find(
            (point) => point.geo_id === element.attributes['geo_id'].textContent
            //element.getAttribute('title')
          )
          point && chart.tooltip.refresh(point)
        } 
      }
    }
  }

  const handleMouseOut = () => {
    const chart = chartRef.current.chart
    if (chart && chart.tooltip) {
      chart.tooltip.destroy()
    }
  }
  let statename =
    regionSelected.toLowerCase() === 'state'
      ? state.state_name + ' (' + state.geo_id + ')'
      :regionSelected.toUpperCase() === 'METRO'? state.state_name + ' (' + state.geo_parent + ')'
      : state.state_name
  return (
    <div style={{ display: 'flex' }} className={styles.Layout}>
      <div
        style={{
          width: '80%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
        title={statename}
      >
        <p
          onMouseOver={(e) => handleMouseOver(e.target)}
          onMouseOut={() => handleMouseOut()}
          className={styles.btn}
          data-title={statename}
          title={statename}
          geo_id={state.geo_id}
          geo_parent={state.geo_parent}
        >
          {statename}
        </p>
      </div>
      <div className={styles.columnRate}>{state.eligibility_rate}</div>
    </div>
  )
}

const SideTable = ({ stateData, chartRef }) => {
  const { regionSelected } = useGeoState()
  const stateDataForDisplayDate = Object.entries(stateData)
  const mappedStateData = stateDataForDisplayDate.map((state) => {
    const stateName = state[1].geo_name
    return { ...state[1], name: stateName, identifier: stateName }
  })

  let filteredStateData = mappedStateData
  const [getFilter, setfilter] = useState('down')
  const sortBy = (action) => {
    if (action === 'up') {
      setfilter('down')
      stateData.sort((a, b) => b.eligibility_rate - a.eligibility_rate)
    } else if (action === 'down') {
      setfilter('up')
      stateData.sort((a, b) => a.eligibility_rate - b.eligibility_rate)
    }
  }
  return (
    <div className={styles.base}>
      <div className={styles.header}>
        <div
          style={{
            width: '100%',
            justifyContent: 'flex-start',
            marginTop: '16px',
            marginBottom: '16px',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div
              style={{
                display: 'inline-flex',
                width: '70%',
              }}
            >
              <span>
                <h5
                  style={{
                    fontFamily: 'Optum Sans',
                    fontSize: '21px',
                    fontWeight: '600',
                    color: '#002677',
                  }}
                >
                  {regionSelected === 'metro'
                    ? toTitleCase(regionSelected) + ' Area Incidence'
                    : toTitleCase(regionSelected) + ' Incidence'}
                </h5>
              </span>
            </div>
          </div>
          {/* <div
            style={{
              fontSize: '12px',
              display: 'flex',
              lineHeight: '18px',
              padding: '1rem 0rem 0',
            }}
          >
            <span> {getVectorImage('Info', '16px', '16px')}</span> &nbsp;&nbsp;
            <div
              style={{ '&::WebkitScrollbar': { width: 0, height: 0 } }}
              className={styles.sideTableHeader}
            >
              {' '}
              Rate represents the incidence of RSV within the population in a
              given week. Change indicates the difference in RSV incidence since
              the previous week.
            </div>
          </div> */}
        </div>
        <div
          style={{
            padding: '0.5rem 0rem',
            paddingBottom: '0.5rem',
            paddingTop: '0.5rem',
            borderTop: '1px solid #CBCCCD',
            borderBottom: '2px solid #002677',
            marginTop: '5px',
            display:'flex',
            justifyContent:'space-between'
          }}
        >
          <div style={{ display: 'inline-flex', width: '48%' }}>
            <h4>{toTitleCase(regionSelected)}</h4>
          </div>
          <div
            style={{
              display: 'inline-flex',
              justifyContent: 'flex-middle',
              cursor: 'pointer',
            }}
          >
            <h4 onClick={() => sortBy(getFilter)}>
              Eligibility Rate{' '}
              <span style={{ marginLeft: '4px' }}>
                {getVectorImage(getFilter)}
              </span>
            </h4>
          </div>
          {/* <div
            style={{
              display: 'inline-flex',
              width: '26%',
              justifyContent: 'flex-middle',
            }}
          >
            <h4>Change</h4>
          </div> */}
        </div>
      </div>

      <div className={styles.scroll}>
        {filteredStateData.length === 0 ?<div style={{ display: 'flex' }} className={styles.Layout}>No data available for the selected filters</div> :
        filteredStateData.map((state,index) => {
          return (
            <Databind state={state} key={state.state_name+index} chartRef={chartRef} />
          )
        })}
      </div>
    </div>
  )
}

export default SideTable
